<div class="stepper">
  @for (step of steps; track $index) {
  <div class="step" [class.active]="$index === currentStep" [class.completed]="$index < currentStep">
    <div class="step-track">
      @if ($index > 0) {
      <div class="step-line"></div>
      }
      <div class="step-dot"></div>
      @if ($index < steps.length - 1) {
      <div class="step-line"></div>
      }
    </div>
    <div class="step-label">{{ step | translate }}</div>
  </div>
  }
</div>
